// extracted by css-extract-rspack-plugin
export default {"info":"ee8bJc9oeg47_xoE","link":"joXpHHhY0Uc3TUPk"};